import { SET_PLAN, REMOVE_PLAN } from './types'

export function setPlan (plan) {
  if (plan) {
    return {
      type: SET_PLAN,
      payload: {
        id: plan.id,
        protocolEntries: plan.protocolEntries,
        metadata: plan.metadata
      }
    }
  } else {
    return {
      type: SET_PLAN,
      payload: {}
    }
  }
}

export function removePlan () {
  return {
    type: REMOVE_PLAN
  }
}
